export const ERROR_MESSAGE = { 
    EMAIL_VALIDATION_MSG : 'Please enter a valid email address',
    OTP_VALIDATION_SIX_DIGIT_MSG : 'Please enter a 6-digit Code',
    USER_INFO_ERROR : 'Please enter a correct input',
};